import { useQuery, useQueryClient } from '@tanstack/react-query';
import tourInstallmentsApi from '@/features/dashboard/tourConfig/api/tourInstallmentsApi.ts';
import { tourPricingQueryKeys } from '@/features/dashboard/tourConfig/api/tourPricing.queryKeys.ts';
import { TourInstallmentForm } from '@/features/dashboard/tourConfig/schemas/tourInstallmentsSchema.ts';
import { tourInstallmentDtoMapper } from '@/features/dashboard/tourConfig/types/TourInstallmentDto.mapper.ts';
import { useDebouncedValue } from '@tanstack/react-pacer';

export default function useGetInstallmentRanges(
  tourId: string,
  installmentsForm: Pick<
    TourInstallmentForm,
    'installments' | 'allowInstallments'
  >,
) {
  const percentagesKey = installmentsForm.installments
    .map((i) => i.basePricePercentage ?? '')
    .join(',');

  const [debouncedKey] = useDebouncedValue(percentagesKey, {
    wait: 300,
  });

  const request = tourInstallmentDtoMapper.fromFormToRequest(
    installmentsForm as TourInstallmentForm,
  );
  return useQuery({
    queryKey: tourPricingQueryKeys.intallmentPriceRanges(tourId!, debouncedKey),
    queryFn: () =>
      tourInstallmentsApi.getInstallmentRanges(tourId!, request.installments),
    staleTime: 1000 * 20,
    enabled: !!tourId && installmentsForm.installments.length > 0,
    retry: false,
  });
}
